export const generateManifest = (isDarkMode: boolean) => {
  const backgroundColor = isDarkMode ? "#151515" : "#ffffff";
  const themeColor = isDarkMode ? "#151515" : "#ffffff";

  return {
    name: "Parallel Operator Portal",
    short_name: "Parallel Operator",
    description: "Parallel Operator Portal for parking lot management",
    start_url: "/",
    display: "standalone",
    background_color: backgroundColor,
    theme_color: themeColor,
    orientation: "portrait-primary",
    icons: [
      {
        src: "/icon.png",
        sizes: "180x180",
        type: "image/png",
        purpose: "any maskable",
      },
      {
        src: "/WebclipIcon.png",
        sizes: "256x256",
        type: "image/png",
        purpose: "any maskable",
      },
    ],
  };
};

export const updateManifest = (isDarkMode: boolean) => {
  const manifest = generateManifest(isDarkMode);
  const themeColor = isDarkMode ? "#191919" : "#ffffff";

  // Update the existing manifest link
  const manifestLink = document.querySelector(
    'link[rel="manifest"]'
  ) as HTMLLinkElement;
  if (manifestLink) {
    // Clean up previous blob URL to prevent memory leaks
    const currentHref = manifestLink.href;
    if (currentHref.startsWith("blob:")) {
      URL.revokeObjectURL(currentHref);
    }

    // Create a new blob URL for the manifest
    const blob = new Blob([JSON.stringify(manifest, null, 2)], {
      type: "application/json",
    });
    const url = URL.createObjectURL(blob);
    manifestLink.href = url;
  }

  // Update theme color meta tags
  const themeColorMeta = document.getElementById(
    "theme-color-meta"
  ) as HTMLMetaElement;
  const msTileColorMeta = document.getElementById(
    "ms-tile-color-meta"
  ) as HTMLMetaElement;

  if (themeColorMeta) {
    themeColorMeta.content = themeColor;
  }

  if (msTileColorMeta) {
    msTileColorMeta.content = themeColor;
  }
};
